import { render, staticRenderFns } from "./CateSelector.vue?vue&type=template&id=57dafc1d&scoped=true&"
import script from "./CateSelector.vue?vue&type=script&lang=js&"
export * from "./CateSelector.vue?vue&type=script&lang=js&"
import style0 from "./CateSelector.vue?vue&type=style&index=0&id=57dafc1d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dafc1d",
  null
  
)

export default component.exports